/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, useMemo } from 'react';
import { IntlProvider } from 'react-intl';
import { I18nProvider } from 'react-aria';
import numbro from 'numbro';
import MainRouter from './MainRouter';
import GlobalContext from './common/GlobalContext';
import messages from './utils/intl/messages';
import NUMBRO_LOCALES from './utils/intl/numbroLocales';

function App() {
  const locale = 'de';

  useEffect(() => {
    document.documentElement.setAttribute('lang', locale);
    numbro.setLanguage(NUMBRO_LOCALES[locale]);
  }, [locale]);

  const localeValue = useMemo(() => ({ locale }));

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {/* I18nProvider is needed for properly localized screen reader
        messages in components built with react-aria */}
      <I18nProvider locale="de-AT">
        <GlobalContext.Provider value={localeValue}>
          <div className="App">
            <MainRouter />
          </div>
        </GlobalContext.Provider>
      </I18nProvider>
    </IntlProvider>
  );
}

export default App;
